import { socket } from '../../api/config';

export default function socketMiddleware() {
  return ({ dispatch, getState }) => next => (action) => {
    if (!action) {
      return;
    }
    if (typeof action === 'function') {
      return next(action);
    }

    const {
      event,  // socket event name to listen
      leave,  // boolean which indicates if event should be unsubscribed on every subsequent action
      handle, // Function or string with action name which will be called/dispatched on event
      func,
      ...rest
    } = action;

    if (!event) {
      return next(action);
    }

    if (leave) {
      socket.removeListener(event);
    }

    let handleEvent = handle;
    if (typeof handleEvent === 'string') {
      handleEvent = (result, ack) => {
        if (func) {
          const state = getState();
          func(state, result);
        }

        dispatch({ type: handle, result: result, ...rest })

        if (ack && typeof ack === 'function') {
          ack();
        }
      };
    }

    return socket.on(event, handleEvent);
  };
}
